<template>
  <div id="app-container" class="app-container-box">
    <div class="list-container-box">
      <div class="type-header">
        <van-button
          class="type-button"
          v-for="(item, index) in check_type_list"
          :key="item.classify_id"
          :class="{ button_select: activeIndex == index }"
          @click="activeTypeClick(index)"
        >
          {{ item.name }}
        </van-button>
        <!-- <van-button
          class="type-button"
          :icon="icon_time"
          @click="show_time_filter = true"
          >打卡时间</van-button
        > -->
      </div>

      <van-list
        class="list-box"
        finished-text="没有更多了"
        :loading="list_loading"
        :finished="list_load_all"
        :immediate-check="false"
        @load="onLoadListen"
        v-if="check_list.length > 0"
      >
        <div
          class="list-item"
          v-for="item in check_list"
          :key="item.id"
          @click="enterItemDetail(item.record_id)"
        >
          <div class="item-header">
            <div class="header-left">
              <div class="list-line-box">
                <span class="list-label"
                  >{{ item.classify_id == 1 ? "运动" : "活动" }}项目</span
                ><span class="list-content">{{ item.item_fmt }}</span>
              </div>
              <div class="list-line-box">
                <span class="list-label"
                  >{{ item.classify_id == 1 ? "运动" : "活动" }}时间</span
                ><span class="list-content">{{ item.start_time_fmt }}</span>
              </div>
              <div class="list-line-box">
                <span class="list-label"
                  >{{ item.classify_id == 1 ? "运动" : "活动" }}地点</span
                ><span class="list-content">{{ item.place_type_fmt }}</span>
              </div>
            </div>
            <img
              class="header-img"
              v-lazy="getListImage(item.images_fmt)"
              alt=""
            />
          </div>
          <div class="item-footer">
            <span class="footer-time">{{ item.create_time_fmt }}</span>
            <span class="footer-text" @click.stop="startPraise(item)"
              >{{ item.praise_num }}
              <img class="footer-img" src="../../assets/icon_fav_select.png"
            /></span>
          </div>
        </div>
      </van-list>
      <van-empty
        description="暂无数据"
        v-else-if="check_list.length == 0 && list_loading == false"
      />
    </div>

    <van-button
      v-if="show_can_check"
      class="enterButton button_select"
      @click="goToCheckPage"
      >去打卡</van-button
    >

    <van-popup :show="show_time_filter" round position="bottom">
      <van-picker-group
        title="选择打开时间"
        :tabs="['选择日期', '选择开始时间', '选择结束时间']"
        next-step-text="下一步"
        @confirm="onConfirmTimeFilter"
        @cancel="show_time_filter = false"
      >
        <van-date-picker v-model="filter_time.selectDate" :max-date="maxDate" />
        <van-time-picker v-model="filter_time.selectStartTime" />
        <van-time-picker v-model="filter_time.selectEndTime" />
      </van-picker-group>
    </van-popup>

    <van-popup
      :show="show_tip"
      round
      position="center"
      closeable
      @close="show_tip = false"
    >
      <div class="popup-tip-box">
        <span>暂无学期打卡</span>
        <van-button @click="show_tip = false">确 认</van-button>
      </div>
    </van-popup>

    <div class="loading-box" v-if="list_loading">
      <van-loading color="#ffffff" vertical>加载中...</van-loading>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { showNotify } from "vant";
import moment from "moment";
import req from "@/js/req";
import { useRouter } from "vue-router";
import User from "@/js/user";

const router = useRouter();
const list_loading = ref(false);
const list_load_all = ref(false);
const show_tip = ref(false);

const activeIndex = ref(0);
const check_type_list = ref([]);
const check_list = ref([]);

const show_time_filter = ref(false);
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1;
const monthStr = month.toString().padStart(2, "0");
const day = date.getDate();
const dayStr = day.toString().padStart(2, "0");
const currentDate = [year.toString(), monthStr, dayStr];
const maxDate = ref(new Date());
const user_info = ref({});
const show_can_check = ref(true);
const filter_time = reactive({
  selectDate: currentDate,
  selectStartTime: ["00", "00"],
  selectEndTime: ["00", "00"],
});

let page = 1;
const limit = 10;
let start_time_filter = false;
let start_time_x = 0;
let end_time_x = 0;

onMounted(() => {
  getCheckTypeList();
  getUserInfo();
});

const getUserInfo = async () => {
  user_info.value = User.getUserInfo();
  const stu_types = ["BENKE", "BOSHI", "SHUOSHI", "LIUXUESHENG"];
  show_can_check.value =
    stu_types.indexOf(user_info.value.stu_type) > -1 &&
    user_info.value.state == 1;
  let data = await req.get(req.path.get_user_info, User.getUTP());
  if (data.number) {
    User.setUserInfo(data);
  }
};
const activeTypeClick = (index) => {
  activeIndex.value = index;
  refleshiLoad();
};

const getCheckTypeList = async () => {
  let data = await req.get(req.path.get_check_type_list);
  check_type_list.value = data.list;
  refleshiLoad();
};
const onLoadListen = () => {
  page += 1;
  getCheckList();
};
const refleshiLoad = () => {
  page = 1;
  check_list.value = [];
  list_load_all.value = false;
  list_loading.value = false;
  getCheckList();
};
const getCheckList = async () => {
  if (check_type_list.value.length == 0) {
    return;
  }
  list_loading.value = true;
  const current_select_type_item = check_type_list.value[activeIndex.value];

  let param = {
    page: page,
    limit: limit,
    user_id: User.getUid(),
    classify_id: current_select_type_item.classify_id,
    ...User.getUTP(),
  };
  if (start_time_filter) {
    param.start_time = start_time_x;
    param.end_time = end_time_x;
  }
  let data = await req.get(req.path.get_check_list, param);
  check_list.value = [...check_list.value, ...data.list];
  list_loading.value = false;
  start_time_filter = false;
  if (check_list.value.length >= data.total) {
    list_load_all.value = true;
  }
};
const onConfirmTimeFilter = () => {
  const year = filter_time.selectDate.join("-");
  const start_time = filter_time.selectStartTime.join(":");
  const end_time = filter_time.selectEndTime.join(":");

  start_time_x = moment(year + " " + start_time).format("X");
  end_time_x = moment(year + " " + end_time).format("X");
  if (end_time_x - start_time_x > 0) {
    start_time_filter = true;
    refleshiLoad();
    show_time_filter.value = false;
  } else {
    showNotify({ type: "warning", message: "结束时间需大于开始时间" });
  }
};

const goToCheckPage = async () => {
  let data = await req.get(req.path.get_clockin_term);
  if (Object.keys(data).length > 0) {
    enterCheckPage();
  } else {
    show_tip.value = true;
  }
};
const enterCheckPage = () => {
  if (activeIndex.value == 0) {
    router.push({
      path: "/sport-check-in",
      query: {
        cid: check_type_list.value[activeIndex.value].classify_id,
      },
    });
  } else {
    router.push({
      path: "/art-check-in",
      query: {
        cid: check_type_list.value[activeIndex.value].classify_id,
      },
    });
  }
};
const startPraise = async (item) => {
  const p = {
    record_id: item.record_id,
    ...User.getUTP(),
  };
  let data = await req.post(req.path.praise_, p);
  if (data > 0) {
    item.praise_num = data;
  }
};
const enterItemDetail = (cid) => {
  router.push({
    path: "/check-detail",
    query: {
      id: cid,
    },
  });
};
const getListImage = (jsonString) => {
    let s =  JSON.parse(jsonString)[0];
    s = `${s}?width=200`
    return s
}

</script>
<style lang="scss" scoped>
.app-container-box {
  position: relative;
  .list-container-box {
    padding: 16px;
    padding-top: 0px;
    padding-bottom: var(--van-tabbar-height);
    margin-bottom: 50px;
    .type-header {
      display: flex;
      // justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      .type-button {
        // padding: 0px 40px;
        margin-top: 20px;
        width: 340px;
        margin-right: 30px;
        &:nth-of-type(2n) {
          margin-right: 0px;
        }
      }
    }
    .list-box {
      .list-item {
        // height: 305px;
        margin-top: 32px;
        background-color: white;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
        border-radius: 8px;
        .item-header {
          display: flex;
          justify-content: space-between;
          padding: 24px 0px;
          margin: 0 24px;
          border-bottom: 1px solid var(--c-line-color);
          .header-left {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;

            .list-line-box {
              display: flex;
              align-items: center;
            }
            .list-label {
              font-size: 28px;
              color: var(--c-text-color-gray-6);
              flex-shrink: 0;
            }
            .list-content {
              font-size: 28px;
              color: var(--c-text-color-black-8);
              padding: 0px 20px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              max-width: 300px;
            }
          }
          .header-img {
            width: 240px;
            height: 180px;
            flex-shrink: 0;
            display: inline-block;
            object-fit: cover;
            background-image: url(../../assets/placeholder.jpg);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            border-radius: 8px;
          }
        }
        .item-footer {
          font-size: 22px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 24px;
          .footer-time {
            color: var(--c-text-color-gray-6);
          }
          .footer-text {
            color: var(--c-text-color-red);
            display: flex;
            align-items: center;
          }
          .footer-img {
            width: 40px;
            height: 40px;
            margin-left: 12px;
          }
        }
      }
    }
  }
}
.popup-tip-box {
  width: 640px;
  height: 408px;
  border: 8px solid var(--van-blue);
  font-size: 32px;
  color: var(--c-text-color-black-8);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0 70px;
  box-sizing: border-box;
  text-align: justify;
  .van-button {
    width: 240px;
    height: 80px;
    font-size: 32px;
    background: var(--c-blue-linear-gradient-1);
    color: white;
    margin-top: 45px;
  }
}
.enterButton {
  position: fixed;
  height: 84px;
  width: 100%;
  left: 0;
  font-size: 32px;
  border-radius: 16px 16px 0px 0px;
  bottom: var(--van-tabbar-height);
}
.loading-box {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
::v-deep .van-loading {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 50px;
  border-radius: 10px;
}
::v-deep .van-button--default {
}
</style>
